<script lang="ts">
import type { HTMLAttributes } from 'vue'

export interface GetStartedProps {
  title?: string
  message?: string
  class?: HTMLAttributes['class']
}
</script>

<script setup lang="ts">
import { CubeIcon } from '@heroicons/vue/24/outline'
import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '#ui-kit/ui/empty'

const props = withDefaults(defineProps<GetStartedProps>(), {
  title: 'Nothing here yet',
})

const slots = defineSlots<{
  default?: () => void
}>()
</script>

<template>
  <Empty :class="props.class">
    <EmptyHeader>
      <EmptyMedia variant="icon">
        <CubeIcon aria-hidden="true" />
      </EmptyMedia>

      <EmptyTitle>{{ title }}</EmptyTitle>

      <EmptyDescription v-if="message">{{ message }}</EmptyDescription>
    </EmptyHeader>

    <EmptyContent v-if="slots.default">
      <slot />
    </EmptyContent>
  </Empty>
</template>
